import * as PIXI from 'pixi.js';
import { spacePositionToPxPosition } from 'js/bubbleCore/view/utils/spacePositionToPxPosition';
import { pxToSpacePosition } from 'js/bubbleCore/view/utils/pxToSpacePosition';
import { Bubble } from '../bubbles/types';
import { IShooterData } from 'js/bubbleCore/types';
import { BubbleView } from 'js/bubbleCore/view/bubbles/BubbleView';
import { BubbleGameBoardView } from 'js/bubbleCore/view/BubbleGameBoardView';
import { Layout } from 'js/layouts/ShooterLayout';
import { IEvent, EventType, IHasEventHandlers, EventHandlers } from 'js/bubbleCore/events';
import { TweenManager } from 'framework/TweenManager/TweenManager';
import { Lerper } from 'framework/utils/Lerper';
import { Range } from 'framework/utils/Range';

export class ShooterView extends PIXI.Container implements IHasEventHandlers {
  public readonly eventHandlers: EventHandlers = {
    [EventType.ShooterUpdated]: (e) => this.onModelUpdate(e.data.shooter),
    [EventType.ChainChanged]: (e) => this.layout.chainAmount.text = `x${e.data.newValue}`,
    [EventType.IncreasedScore]: (e) => this.scoreLerper.setTarget(e.data.amount),
  };

  private readonly layout: Layout;
  private readonly pointer: PIXI.Sprite;
  private readonly boardView: BubbleGameBoardView;
  private readonly scoreLerper: Lerper;

  private currentBubble: BubbleView;
  private nextBubble: BubbleView;

  constructor(
    model: IShooterData,
    boardView: BubbleGameBoardView,
    tweenManager: TweenManager,
  ) {
    super();
    this.boardView = boardView;
    this.layout = new Layout();
    this.currentBubble = new BubbleView({boardView});
    this.nextBubble = new BubbleView({boardView});
    this.layout.currentBubbleContainer.addChild(this.currentBubble);
    this.layout.nextBubbleContainer.addChild(this.nextBubble);
    this.addChild(this.layout.root);

    this.scoreLerper = new Lerper({
      initValue: 0,
      lerp: 0.2,
      snap: 0.5,
      autoUpdate: true,
      range: new Range(0, Infinity),
      destroySignal: this.layout.scoreAmount.onDestroyed,
    });

    this.scoreLerper.signals.onValueUpdate.add((value) => {
      this.layout.scoreAmount.text = Math.round(value).toString();
    });

  }

  public onModelUpdate(model: IShooterData): void {
    const {x, y} = model.position;
    spacePositionToPxPosition(
      x, y, this.boardView.getHexPixelSize(), this.layout.root.position as PIXI.Point
    );

    if (model.bubblesQueue[0]) this.currentBubble.reset(model.bubblesQueue[0])
    if (model.bubblesQueue[1]) this.nextBubble.reset(model.bubblesQueue[1]);
  }
}